module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inputNumber"
  }, [_c('div', {
    staticClass: "el-j",
    class: {
      disabled: _vm.currentValue <= _vm.min
    },
    on: {
      "click": _vm.handleDown
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jian1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "el-i"
  }, [_c('input', {
    staticClass: "el-input_inner",
    attrs: {
      "type": "tel",
      "autocomplete": "off",
      "max": "10",
      "min": "1",
      "maxlength": _vm.maxlength
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "change": _vm.handleChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "el-p",
    class: {
      disabled: _vm.currentValue >= _vm.max
    },
    on: {
      "click": _vm.handleUp
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jia1"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6c22ba84","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/inputNumber.vue
// module id = 1804
// module chunks = 107